import { useState } from "react";
import { SubTabs, type SubTabSpec } from "../components/ui/SubTabs";
import { PnlTab } from "../components/mesa/PnlTab";
import { ExposicaoTab } from "../components/mesa/ExposicaoTab";
import { FaTab } from "../components/mesa/FaTab";
import { CurvaMercadoTab } from "../components/mesa/CurvaMercadoTab";
import { ControlePldPage } from "../components/mesa/ControlePldPage";
import { JurosInflacaoTab } from "../components/mesa/juros/JurosInflacaoTab";
import { SimuladorTab } from "../components/mesa/SimuladorTab";

type MesaTab = "pnl" | "exposicao" | "fa" | "curva" | "pld" | "juros" | "simulador";

const TABS: SubTabSpec<MesaTab>[] = [
  { id: "pnl", label: "PnL" },
  { id: "exposicao", label: "Exposição" },
  { id: "fa", label: "FA" },
  { id: "curva", label: "Curva de Mercado" },
  { id: "pld", label: "Controle PLD" },
  { id: "juros", label: "Juros & Inflação" },
  // #28 PR-3: what-if descartável — só-sócio por herança (Mesa inteira já
  // fica atrás do Basic auth; nada gravado, o endpoint garante).
  { id: "simulador", label: "Simulador" },
];

export function MesaOperacoesPage({
  onTabChange,
}: {
  onTabChange?: (t: MesaTab) => void;
}) {
  const [tab, setTab] = useState<MesaTab>("pnl");

  function change(t: MesaTab) {
    setTab(t);
    onTabChange?.(t);
  }

  return (
    <div>
      <SubTabs tabs={TABS} active={tab} onChange={change} />
      <div className="mt-6">
        {tab === "pnl" && <PnlTab />}
        {tab === "exposicao" && <ExposicaoTab />}
        {tab === "fa" && <FaTab />}
        {tab === "curva" && <CurvaMercadoTab />}
        {tab === "pld" && <ControlePldPage />}
        {tab === "juros" && <JurosInflacaoTab />}
        {tab === "simulador" && <SimuladorTab />}
      </div>
    </div>
  );
}
